import { Component, EventEmitter, HostListener, Output } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { environment } from "@edp-environments/environment";

@Component({
    selector: "edp-breadcrumb-mobile",
    templateUrl: "./edp-breadcrumb-mobile.component.html",
    styleUrls: ["./edp-breadcrumb-mobile.component.scss"]
})
export class EdpBreadcrumbMobileComponent {

    @Output() hasMobileBreadcrumb = new EventEmitter<boolean>();

    public isApp: boolean;
    public scroll: boolean;
    public showMobileBreadcrumb = false;
    public mobileBreadcrumb: string = null;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute) {
            this.isApp = environment.isApp;
            this.checkMobileBreadcrumb();
            this.subscribeNavigationEnd();
    }

    @HostListener("window:scroll", [])
    onScroll(): void {
        if (window.scrollY === 0) {
            this.scroll = false;
        } else {
            this.scroll = true;
        }
        this.checkMobileBreadcrumb();
    }

    @HostListener("window:resize", ["$event"])
    onResize(event) {
        this.checkMobileBreadcrumb();
    }

    subscribeNavigationEnd() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.checkMobileBreadcrumb();
            }
        });
    }

    private checkMobileBreadcrumb() {
        this.showMobileBreadcrumb = false;
        this.mobileBreadcrumb = this.getBreadcrumb();
        this.showMobileBreadcrumb = !this.isApp && this.mobileBreadcrumb !== null && window.innerWidth < SCREEN_SIZES.LG
            && (window.innerWidth < SCREEN_SIZES.WDGT || !this.router.url.includes("/inicio") || this.scroll);
        this.hasMobileBreadcrumb.emit(this.showMobileBreadcrumb);
    }

    private getBreadcrumb() {
        let child = this.activatedRoute.firstChild;
        while (child) {
            if (child.firstChild) {
                child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data.mobileBreadcrumb) {
                return child.snapshot.data.mobileBreadcrumb;
            } else {
                return null;
            }
        }
    }
}
